<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 15 16">
    <path
      d="M0.544189 1.67575C0.544189 1.18901 0.938769 0.794434 1.42551 0.794434H13.2604C13.7471 0.794434 14.1417 1.18901 14.1417 1.67575V1.67575C14.1417 2.16249 13.7471 2.55707 13.2604 2.55707H1.42551C0.938769 2.55707 0.544189 2.16249 0.544189 1.67575V1.67575ZM0.544189 14.8955C0.544189 14.4088 0.93877 14.0142 1.42551 14.0142H8.72787C9.21461 14.0142 9.60919 14.4088 9.60919 14.8955V14.8955C9.60919 15.3823 9.21461 15.7769 8.72787 15.7769H1.42551C0.938769 15.7769 0.544189 15.3823 0.544189 14.8955V14.8955ZM0.544189 10.4889C0.544189 10.0022 0.938769 9.60763 1.42551 9.60763H13.2604C13.7471 9.60763 14.1417 10.0022 14.1417 10.4889V10.4889C14.1417 10.9757 13.7471 11.3703 13.2604 11.3703H1.42551C0.938769 11.3703 0.544189 10.9757 0.544189 10.4889V10.4889ZM0.544189 6.08235C0.544189 5.59561 0.93877 5.20103 1.42551 5.20103H8.72787C9.21461 5.20103 9.60919 5.59561 9.60919 6.08235V6.08235C9.60919 6.56909 9.21461 6.96367 8.72787 6.96367H1.42551C0.938769 6.96367 0.544189 6.56909 0.544189 6.08235V6.08235Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
